import { Instagram, Facebook, House } from "lucide-react";
import { BRAND, NAV_LINKS } from "../../data/content";
import { scrollToHash } from "@/lib/scrollToHash";
import fullLogo from "../../assets/blacklion-full-logo.png";

const SOCIALS = [
  { icon: Instagram, href: BRAND.socials.instagram, label: "Instagram" },
  { icon: Facebook, href: BRAND.socials.facebook, label: "Facebook" },
  { icon: House, href: BRAND.socials.houzz, label: "Houzz" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-[#c9a24d]/25 bg-[#0a0a0a] py-16 lg:py-20">
      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#home" onClick={(e) => scrollToHash(e, "#home")}>
              <img src={fullLogo} alt="Blacklion Construction Group Inc." className="h-40 w-auto object-contain" />
            </a>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-neutral-500">
              Toronto general contractor delivering premium custom homes,
              renovations and additions across the Greater Toronto Area.
              Building with strength and precision.
            </p>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">Navigate</h4>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={(e) => scrollToHash(e, l.href)}
                    className="text-sm text-neutral-400 transition-colors hover:text-gold"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">Contact</h4>
            <ul className="mt-5 space-y-3 text-sm text-neutral-400">
              <li><a href={BRAND.phoneHref} className="transition-colors hover:text-gold">{BRAND.phone}</a></li>
              <li><a href={`mailto:${BRAND.email}`} className="transition-colors hover:text-gold">{BRAND.email}</a></li>
              <li>{BRAND.serviceArea}</li>
            </ul>
            <div className="mt-6 flex gap-3">
              {SOCIALS.map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="flex h-10 w-10 items-center justify-center border border-white/15 text-gold transition-all hover:bg-gold hover:text-black"
                >
                  <Icon size={17} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="gold-divider my-10" />
        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">Service Areas</h4>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-neutral-400">
            Proudly serving {BRAND.serviceCities.join(", ")} and the surrounding Greater Toronto Area.
          </p>
        </div>

        <div className="gold-divider my-10" />
        <div className="flex flex-col items-center justify-between gap-4 text-xs text-neutral-600 sm:flex-row">
          <p>© {new Date().getFullYear()} Blacklion Construction Group Inc. All rights reserved.</p>
          <p>Licensed &amp; Insured · GTA</p>
        </div>
      </div>
    </footer>
  );
};
